import React, { useState } from 'react';
import "./FAQ.css"
export default function FAQ() {
    //const [faqOne,setFaqOne]=useState(false)
    const [openIndex, setOpenIndex] = useState(null);
const faqArray = [
  {
    question: "1. What kind of furniture does Morara Homes offer?",
    answer: "We specialize in handcrafted furniture for living rooms, bedrooms, dining areas, and offices — blending comfort, style, and durability."
  },
  {
    question: "2. Do you handle both small and large orders?",
    answer: "Yes! From a single custom piece to full home or office setups, we design furniture to suit your needs and space."
  },
  {
    question: "3. Can I request a custom design?",
    answer: "Absolutely. Every client is unique, so we work with you to create custom designs that match your style, space, and preferences."
  },
  {
    question: "4. Do you provide delivery and setup?",
    answer: "Yes, we offer delivery and professional setup services to ensure your furniture is perfectly placed in your space."
  },
  {
    question: "5. How far in advance should I order?",
    answer: "For ready-made pieces, delivery can be arranged within days. For custom designs, we recommend placing your order 2–6 weeks in advance depending on complexity."
  },
  {
    question: "6. Do you deliver outside Nairobi?",
    answer: "Yes, we deliver across Kenya and can arrange transportation depending on your location."
  },
  {
    question: "7. Do you offer eco-friendly or sustainable options?",
    answer: "Yes, we use high-quality and sustainable materials where possible, and we accommodate clients who prefer eco-friendly furniture solutions."
  },
  {
    question: "8. How do I order from Morara Homes?",
    answer: "Simply reach out through our website, social media, or phone number to discuss your needs and place an order."
  }
];




    const final = faqArray.map((thing, index) => (<div className="faq-item">
        <div className="question" onClick={() => setOpenIndex(openIndex === index ? null : index)}>{thing.question}</div>
        {openIndex === index && (<div className="answer">{thing.answer}</div>)}


    </div>))


    return (
        <div className='faq-body'>
            <div className="faq-container">
                <h1>Morara Homes Furniture FAQ </h1>
                {final}

            </div>

          
            
        </div>
    )
}